import React from 'react'
import PropTypes from 'prop-types'
import AffinityIcon from 'components/AffinityIcon'
import { EvaluationIconStyled } from 'components/patterns/Icon/IconsStyled'

const CarryFrom = ({
  onClick,
  highlightAffinity,
  affinityGroupNumber,
  isSimulating,
  evaluation,
}) => {
  const showEvaluationIcon = !highlightAffinity && isSimulating
  const showCarrySymbol = !highlightAffinity && !isSimulating

  return (
    <span className="multiple-query-carry" onClick={onClick}>
      {highlightAffinity && <AffinityIcon groupNumber={affinityGroupNumber} />}
      {showEvaluationIcon && (
        <EvaluationIconStyled useNodeStyles evaluation={evaluation} />
      )}

      {showCarrySymbol && <span className="relation-symbol carry-from" />}
    </span>
  )
}

CarryFrom.propTypes = {
  onClick: PropTypes.func,
  highlightAffinity: PropTypes.bool,
  affinityGroupNumber: PropTypes.number,
  isSimulating: PropTypes.bool,
  evaluation: PropTypes.bool,
}

export default CarryFrom
